/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentStrategyEnum = {
    Advance: 'advance',
    Back: 'back'
} as const;
export type PaymentStrategyEnum = typeof PaymentStrategyEnum[keyof typeof PaymentStrategyEnum];


export function instanceOfPaymentStrategyEnum(value: any): boolean {
    for (const key in PaymentStrategyEnum) {
        if (Object.prototype.hasOwnProperty.call(PaymentStrategyEnum, key)) {
            if (PaymentStrategyEnum[key as keyof typeof PaymentStrategyEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaymentStrategyEnumFromJSON(json: any): PaymentStrategyEnum {
    return PaymentStrategyEnumFromJSONTyped(json, false);
}

export function PaymentStrategyEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentStrategyEnum {
    return json as PaymentStrategyEnum;
}

export function PaymentStrategyEnumToJSON(value?: PaymentStrategyEnum | null): any {
    return value as any;
}

export function PaymentStrategyEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): PaymentStrategyEnum {
    return value as PaymentStrategyEnum;
}

